module.exports = __webpack_public_path__ + "assets/img/course_card_landing_bg.svg";